import Route from 'cio/routes/base';
import { inject as service } from '@ember/service';
import { getOwner } from '@ember/application';
import SignupService from 'cio/services/signup';
import SignupIndexController from 'cio/pods/signup/index/controller';
import Transition from '@ember/routing/-private/transition';
import SignupController from '../controller';

export default class SignupIndexRoute extends Route {
  @service signup!: SignupService;

  model() {
    return this.modelFor('signup');
  }
  setupController(controller: SignupIndexController, model: any, transition: Transition) {
    super.setupController(controller, model, transition);

    let { queryParams } = this.router.currentRoute;

    // we don't want to sync sign-up form values *TO* the URL
    // so instead of binding query params to form values, we're copying them once here
    let signupController = getOwner(controller).lookup('controller:signup') as SignupController;
    signupController.setFormValue('email', queryParams.email ?? '');
    signupController.setFormValue('firstName', queryParams.first ?? '');
    signupController.setFormValue('lastName', queryParams.last ?? '');

    controller.setDefaults();
  }
}
